import { useState, useEffect, useCallback, useRef } from 'react';
import I18n from 'I18n';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function DataTokenTooltipManager(props) {
  const {
    editor
  } = props;
  const [title, setTitle] = useState('');
  const [target, setTarget] = useState(null);
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      setTitle('');
      setTarget(null);
    }
  }, [lastTarget]);
  useEffect(() => {
    const handleMouseOver = ({
      target: newTarget
    }) => {
      if (!newTarget) {
        handleRemove();
        return;
      }
      const typedTarget = newTarget;
      const hasDataSensitivity = typedTarget.getAttribute('data-mce-data-sensitivity') === 'true';
      const hasTruncatedLabel = typedTarget.getAttribute('data-mce-truncated-label') === 'true';
      if (newTarget === lastTarget.current) {
        return;
      } else if (hasDataSensitivity) {
        setTitle(I18n.text('TinymcePlugins.hsdatatoken.dataSensitivityTooltip'));
        setTarget(typedTarget);
      } else if (typedTarget.hasAttribute('data-mce-token-path') && hasTruncatedLabel) {
        setTitle(typedTarget.getAttribute('data-mce-property-label') || '');
        setTarget(typedTarget);
      } else {
        handleRemove();
      }
    };
    editor.on('mouseover', handleMouseOver);
    return () => {
      editor.off('mouseover', handleMouseOver);
    };
  }, [editor, lastTarget, handleRemove]);
  return /*#__PURE__*/_jsx(UITooltip, {
    "data-test-id": "data-token-tooltip",
    open: !!target,
    target: target,
    title: title,
    children: /*#__PURE__*/_jsx(_Fragment, {})
  });
}